export default (editor, opts = {}) => {
    const DOMC = editor.DomComponents;
    const TYPE = DOMC.getType('default');
    const MODEL = TYPE.model;
    const VIEW = TYPE.view;
    const BM = editor.BlockManager;

    var model = MODEL.extend({

        defaults:{
            ...MODEL.prototype.defaults,  
            tagName:'div',
            attributes:{
                "data-slg-type":"C-LAYER",
            },
            style: {
                "min-width": '100px',
                "min-height": '100px'
            },
            // draggable:false,
            // droppable: false,
            components: [
                {
                    tagName:'div',
                    classes:['form-group'],
                    components:[
                        {
                            type:"label",
                            content:"Label"
                        },
                        {
                            type:"input",
                            attributes:{
                                type:"text"
                            },
                            classes:['form-control']
                        },
                    ]
                },
                {
                    tagName:'div',
                    classes:['form-group'],
                    components:[
                        {
                            type:"label",
                            content:"Label"
                        },
                        {
                            type:"input",
                            attributes:{
                                type:"text"
                            },
                            classes:['form-control']
                        },
                    ]
                },
                {
                    tagName:'div',
                    classes:['form-group'],
                    components:[
                        {
                            type:'button',
                            attributes:{
                                type:"button",
                                "data-slg-layer-control":"next"
                            },
                            classes:['btn','btn-primary'],
                            content:"Send"
                        }
                    ]
                }
            ]
        }
    },{
        isComponent(el) {
            if(el && el.getAttribute && el.getAttribute('data-slg-type') == "C-LAYER")
                return { type:'C-LAYER' }
        }
    });

    var view = VIEW.extend({

        init: function () {
          let component = this.model;
        },
        onRender() {
            let component = this.model;
        },
    });

    DOMC.addType('C-LAYER', {
        model:model,
        view:view,
    });
};
  